// extracted by mini-css-extract-plugin
module.exports = {"widget":"TypeformSection_widget__H1nYu","water":"TypeformSection_water__bqq8E","rotate":"TypeformSection_rotate__A0Iin","pulsate":"TypeformSection_pulsate__CBZzd"};